<template>
<!--  <Panel :header="$t('overviewCreatedForPeriod') + (periodLabel ? ' (' + periodLabel + ')' : '')" :toggleable="false" :collapsed="isCollapsed">-->
  <Panel :toggleable="false" :collapsed="isCollapsed">
    <template #header>
      <div class="statistics-panel-header">
        <b>{{ $t('overviewCreatedForPeriod') }}</b>
        <span v-if="periodLabel" class="p-text-secondary statistics-panel-date">
          {{ periodLabel }}
        </span>
      </div>
    </template>
    <div class="datatable-wrapper" v-if="managerCommonStat?.length">
      <table class="p-datatable p-datatable-striped p-datatable-sm p-datatable-hoverable-rows positions-table">
        <thead class="p-datatable-tbody">
        <tr class="table-opened-info__header-row">
          <th style="width: 22%">{{ $t('overviewCreator') }}</th>
          <th style="width: 13%">{{ $t('createdOrdersLabel') }}</th>
          <th style="width: 13%">{{ $t('createdOrderPositionsLabel') }}</th>
          <th style="width: 13%">{{ $t('createdEstimatesLabel') }}</th>
          <th style="width: 13%">{{ $t('createdEstimatePositionsLabel') }}</th>
          <th style="width: 13%">{{ $t('Customers') }}</th>
          <th style="width: 13%">{{ $store.getters.isForkliftTenant ? $t('Equipment') : $t('Cars') }}</th>
        </tr>
        </thead>
        <tbody class="p-datatable-tbody">
        <tr v-for="(statistics, index) of managerCommonStat" :key="index">
          <td>{{ statistics.is_customer_stat ? $t('Customers') : statistics.is_unassigned_stat ? $t('overviewUnassignedEmployee') : statistics.name }}</td>

          <td>{{ Number(statistics.orders_count || 0) }}</td>

          <td>
            <template v-if="!statistics.is_customer_stat && !statistics.is_unassigned_stat">
              {{ Number(statistics.order_positions_count || 0) }}
            </template>
            <i v-else class="ti-minus"/>
          </td>

          <td>{{ Number(statistics.offers_count || 0) }}</td>

          <td>
            <template v-if="!statistics.is_customer_stat && !statistics.is_unassigned_stat">
              {{ Number(statistics.offer_positions_count || 0) }}
            </template>
            <i v-else class="ti-minus"/>
          </td>
          <td>{{ Number(statistics.customers_count || 0) }}</td>
          <td>{{ Number(statistics.vehicles_count || 0) }}</td>
        </tr>

        <tr class="table-opened-info__row--total">
          <td class="no-bottom-border">{{ $t('Total') }}</td>
          <td class="no-bottom-border">{{ totals.ordersCount }}</td>
          <td class="no-bottom-border">{{ totals.orderPositionsCount }}</td>
          <td class="no-bottom-border">{{ totals.estimatesCount }}</td>
          <td class="no-bottom-border">{{ totals.estimatePositionsCount }}</td>
          <td class="no-bottom-border">{{ totals.customersCount }}</td>
          <td class="no-bottom-border">{{ totals.vehiclesCount }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else style="text-align: center; padding: 20px;">
      {{ $t('No data available' )}}
    </div>
  </Panel>
</template>

<script>
// import formatMixins from "@/mixins/formatMixins";
export default {
  // mixins: [ formatMixins ],
  name: 'ManagerCommonPanel',
  props: {
    periodLabel: { type: String, default: '' },
    managerCommonStat: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      isCollapsed: false,
    }
  },
  computed: {
    totals() {
      return this.managerCommonStat.reduce((acc, item) => {
        acc.ordersCount += Number(item.orders_count || 0)

        if (!item.is_customer_stat && !item.is_unassigned_stat) {
          acc.orderPositionsCount += Number(item.order_positions_count || 0)
          acc.estimatePositionsCount += Number(item.offer_positions_count || 0)
        }

        acc.estimatesCount += Number(item.offers_count || 0)
        acc.customersCount += Number(item.customers_count || 0)
        acc.vehiclesCount += Number(item.vehicles_count || 0)

        return acc
      }, {
        ordersCount: 0,
        orderPositionsCount: 0,
        estimatesCount: 0,
        estimatePositionsCount: 0,
        customersCount: 0,
        vehiclesCount: 0,
      })
    }
  },
}
</script>
